import mapKnownValues from "../utils/mapKnownValues";

export type UserResponse = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  emailVerified: boolean;
  userId: string;
};

export default class User {
  firstName = "";
  lastName = "";
  phone = "";
  email = "";
  emailVerified = false;
  userId = "";

  constructor(params: Partial<User> = {}) {
    mapKnownValues(this, params);
  }

  get name() {
    return `${this.firstName} ${this.lastName}`;
  }

  static fromAPI(response: UserResponse) {
    return new User({
      ...response,
      phone: response.phoneNumber,
    });
  }
}
